import { render, staticRenderFns } from "./todoRead.vue?vue&type=template&id=5f69b797&scoped=true&"
import script from "./todoRead.vue?vue&type=script&lang=js&"
export * from "./todoRead.vue?vue&type=script&lang=js&"
import style0 from "./todoRead.vue?vue&type=style&index=0&id=5f69b797&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f69b797",
  null
  
)

export default component.exports